/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import { verticalListSortingStrategy } from '@dnd-kit/sortable';
import { connect } from 'react-redux';
import SyncIcon from '@material-ui/icons/Sync';
import * as actions from '../../actions/index';
import {
  Modal,
  Input,
  Button,
  Title,
  TableFooter,
  SortableList,
  DraggableImage,
  ExpandablePanel,
  ProductList,
  Checkbox,
  EmptyView,
  ShopModal,
  SearchBar
} from '../../components';
import { checkAccess } from '../../utils/admins';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import {
  handleNewSection,
  handleMountSection,
  handleSubmitSection,
  handleRemoveSection,
  handleStartDrag,
  changeActivationSection,
  handleRemoveImage,
  setCroppedImage,
  handleChangeSection,
  handleDragSection,
  handleChangeExpend,
  showConfirmation,
  sortedSections,
  handleDuplicateSection,
  synchronizingData,
  handleRemoveSectionSubmit,
  handleDisplayMenu,
  handleCloseMenu,
  getSections,
  handleSearchChange,
  setImageConfig
} from './Products.services';
import { styles } from './Products.styles';
import { mainColor } from '../../constants';
import { ReactComponent as ImportedSVG } from '../../assets/pictures/box.svg';
import {
  EMPTY_DESIGN_PRODUCTS_TEXT,
  EMPTY_DESIGN_PRODUCTS_TITLE
} from '../../constants/dishopInfo';
import { SYNC_SHOPS, SYNC_POS } from '../../constants/dataConfig';
import { handleSynchronisationToggle, debouncedUpdate, getShopsToSynchronise } from '../../utils/shopUtils';
import 'rc-time-picker/assets/index.css';
import 'react-datepicker/dist/react-datepicker.css';
import { getShopId } from 'src/apis/firebase';
import { checkIntegrationAccess } from '../../utils/externalIntegration'
import ActivationRange from '../../components/ActivationRange'
import store from '../../utils/store';
import { listenMenusPOSRealTime } from '../../apis/firebase';
import { isStringNotNull } from '../../utils/tools'
const INITIAL_STATE = {
  sectionKey: '',
  isLoadingProduct: false,
  isLoadingSection: false,
  categoriesArray: [],
  product: {},
  section: {},
  isSync: false,
  synchronize: false,
  activeId: null,
  sectionModalOpen: false,
  sectionUpdateModalOpen: false,
  productModalOpen: false,
  updateProductModalOpen: false,
  removeProductModal: false,
  removeSectionModal: false,
  sections: {},
  isSorting: false,
  showModal: false,
  selectedShops: {},
  isAllMenu: false,
  isSuppression: false,
  anchorEl: null,
  highlightSection: {},
  searchTerm: ''
};
class Products extends Component {
  constructor() {
    super();
    this.state = INITIAL_STATE;
    this.handleStateChange = this.handleStateChange.bind(this);


  }
  handleStateChange(newState) {
    this.setState(newState);
  }
  async componentDidMount() {
    await debouncedUpdate(this.props.menu);
    await listenMenusPOSRealTime(store.dispatch, this.props.shopId);
  }
  async componentWillReceiveProps(nextProps) {
    const { menu, shopId } = nextProps;
    const { menu: oldMenu, shopId: oldShopId } = this.props;
    if (!_.isEqual(oldMenu?.sections, menu?.sections)) {
      await debouncedUpdate(menu);
    }
    if (!_.isEqual(oldShopId, shopId)) {
      await listenMenusPOSRealTime(store.dispatch, shopId);
      this.setState({ searchTerm: '' })
    }
  }

  renderUpdateSection = (nbShopsToSync) => {
    const {
      section = {},
      sectionModalOpen,
      sectionUpdateModalOpen,
      isLoadingSection,
      sectionName = '',
      synchronize
    } = this.state;
    const { name = '', description = '', iconUrl = [], hideProductName = false } = section;
    const { classes, shops, shopId } = this.props;
    return (
      <Modal
        color='secondary'
        title={sectionModalOpen ? 'Nouvelle section' : `Modifier la section ${sectionName}`}
        header
        width='600px'
        handleClose={() => {
          if (sectionModalOpen || sectionUpdateModalOpen) {
            this.setState({ sectionModalOpen: false, sectionUpdateModalOpen: false, synchronize: false, isSuppression: false });
          } else {
            this.setState({ sectionModalOpen: true, sectionUpdateModalOpen: true, synchronize: false, isSuppression: false });
          }
        }}
        showCancelBtn
        loading={!synchronize && isLoadingSection}
        isOpen={sectionModalOpen || sectionUpdateModalOpen}
        onClick={() => {
          if (synchronize) {
            this.setState({
              selectedShops: { [shopId]: shops[shopId] },
              showModal: true,
              isAllMenu: false,
              isSuppression: false
            })
          }
          else {
            this.setState({
              selectedShops: {},
              isSuppression: false
            })
            handleSubmitSection(this);
          }

        }}
        modalBodyClass='py-0'
        btnTxt='Enregistrer'
      >
        <div className={classes.modalStyle}>
          <span className={classes.text}>Créations</span>
          <div className={`row w-100 mt-2 d-flex justify-content-center mx-0 `}>
            <DraggableImage
              multiple={false}
              maxFileSize={500000}
              aspect={1.25}
              imgExtension={['.png', '.jpeg', '.jpg']}
              picture={!Array.isArray(iconUrl) ? [{ imageUrl: iconUrl }] : iconUrl}
              defaultText={"Drag & Drop l'image (500Ko max)"}
              setCroppedImage={croppedImage => setCroppedImage(croppedImage, this)}
              setImageConfig={imageConfig => setImageConfig(imageConfig, this)}
              saveConfigOnly
              handleRemove={() => handleRemoveImage(this)}
            />
            <div className={`mb-2 p-0 sectionUpdate`} >
              <Input
                autoFocus
                margin='dense'
                id='name'
                label='Nom de la section'
                type='text'
                value={name}
                classes={{ label: classes.labelStyle }}
                onChange={e => handleChangeSection(e, this)}
                fullWidth
              />
              <Input
                margin='dense'
                id='description'
                label='Description'
                type='text'
                value={description}
                onChange={e => handleChangeSection(e, this)}
                fullWidth
              />
            </div>
          </div>
          <span className={`${classes.text}`}>Définitions</span>
          <ActivationRange
            item={section}
            setState={this.handleStateChange}
            classes={this.props.classes}
          />
          {checkAccess('features', 'globalProduct') && (
            <Checkbox
              value={synchronize}
              name='synchronize'
              text='Synchroniser cette section sur un ou plusieurs magasins'
              onClick={() => this.setState({ synchronize: !synchronize })}
              hidden={nbShopsToSync === 1}
            />
          )}
          <Checkbox
            value={hideProductName}
            name='hideProductName'
            text='Cacher les noms des produits'
            onClick={() => this.setState({ section: { ...section, hideProductName: !hideProductName } })}
          />
        </div>
      </Modal>
    );
  };

  renderShops = (classes, shopId) => {
    const { showModal, selectedShops = {}, isLoadingSection, isAllMenu, sectionKey, isSuppression } = this.state;
    return (
      <ShopModal
        classes={classes}
        shopId={shopId}
        showModal={showModal}
        selectedShops={selectedShops}
        loading={isLoadingSection}
        onClick={() => isSuppression ? handleRemoveSectionSubmit(sectionKey, this) : isAllMenu ? synchronizingData(this, selectedShops) : handleSubmitSection(this)}
        handleToggle={handleSynchronisationToggle}
        component={this}
        text={`Sélectionnez les magasins dont vous voulez ${isSuppression ? 'supprimer' : 'synchroniser'} ${isAllMenu ? 'votre menu' : 'cette section'}:`}
        title={`${isSuppression ? 'Supprimer' : 'Synchroniser'} ${isAllMenu ? 'votre menu' : 'cette section'}:`}
        isSuppression={isSuppression}
      />
    );
  };


  renderProductList = (key, products) => {
    const { sections = {} } = this.props;
    return <ProductList key={key} products={products} sectionKey={key} section={sections[key]} handleStateChange={this.handleStateChange} />;
  };

  renderSectionItem = (sectionKey, handleProps, sections) => {
    const { expanded, highlightSection } = this.state;
    const section = sections[sectionKey];
    if (section) {
      const { products = {}, hidden } = section;
      return (
        <div className="section" data-section-key={sectionKey}>
          <ExpandablePanel
            className={{
              backgroundColor: !hidden && mainColor.colorMediumGray
            }}
            handleProps={handleProps}
            item={section}
            isSection
            expanded={expanded === sectionKey}
            onExpand={(e, expanded) => { handleChangeExpend(e, expanded, sectionKey, this) }}
            onRemove={e => { handleRemoveSection(e, sectionKey, this); this.setState({ isSuppression: true, synchronize: false }) }}
            onUpdate={e => handleMountSection(e, section, this)}
            onDuplicate={e => handleDuplicateSection(e, section, this)}
            renderItems={() => this.renderProductList(sectionKey, products)}
            onActivationChange={e => changeActivationSection(e, sectionKey)}
            isHighlighted={highlightSection?.key === sectionKey}
          />
        </div>
      );
    }
    return true;
  };

  renderCreateSectionButton = () => {
    return (
      <Button
        className='btn-xs-block'
        color='primary'
        onClick={() => handleNewSection(this)}
        disabled={!checkAccess('features', 'productAndOption') || checkIntegrationAccess('products', 'hideCreateSection')}
      >
        <div className='row justify-content-center align-items-center mr-0 ml-0'>
          <AddIcon />
          <p className='m-0 ml-2'> Créer une nouvelle section</p>
        </div>
      </Button>
    );
  };
  renderMenu = () => {
    const { shopId, nbShops } = this.props;
    const { anchorEl } = this.state;
    return (
      <Menu
        id='simple-menu'
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => handleCloseMenu(this)}
      >
        {_.map([SYNC_SHOPS, SYNC_POS], type => {
          return <MenuItem onClick={() =>
            type === SYNC_POS
              ? showConfirmation(this, SYNC_POS)
              : nbShops === 2
                ? showConfirmation(this, SYNC_SHOPS)
                : this.setState({
                  selectedShops: { [shopId]: getShopsToSynchronise()[shopId] },
                  showModal: true,
                  isAllMenu: true,
                  isSuppression: false,
                  anchorEl: null
                })}>{type}</MenuItem>;
        })}
      </Menu>
    );
  };
  render() {
    const { showHelpModal, marketplace, page, classes, shopId, nbShops, externalIntegrationConfiguration, generalAdmin } = this.props;
    const sections = getSections(this)
    const { rowsPerPage } = page;
    const { activeId, expanded, showModal } = this.state;
    const shopSync = checkAccess('features', 'globalProduct') && !marketplace;
    const POSSync = checkIntegrationAccess('products', 'pullCart') && (generalAdmin && externalIntegrationConfiguration?.allowSynchro)
    const displayMenu = shopSync && POSSync
    const nbShopsToSync = _.size(getShopsToSynchronise())
    return (
      <div className='px-4 pb-4 noselect'>
        <Title title='Produits' onClick={() => showHelpModal('produits')} />
        {!_.size(this.props.sections) > 0 ? (
          <EmptyView
            className={classes.svg}
            src={ImportedSVG}
            viewBox='0 0 256 256'
            title={EMPTY_DESIGN_PRODUCTS_TITLE}
            text={EMPTY_DESIGN_PRODUCTS_TEXT}
          >
            {this.renderCreateSectionButton()}
            {displayMenu && (
              <div className='pt-3'>
                <Button
                  className='btn-xs-block'
                  onClick={() => showConfirmation(this, SYNC_POS)}
                  outlined
                  color='secondary'
                >
                  <div className='row justify-content-center align-items-center mr-0 ml-0'>
                    <SyncIcon />
                    <p className='m-0 ml-2'>  Synchroniser avec la caisse</p>
                  </div>


                </Button >
                {displayMenu && this.renderMenu()
                }
              </div>
            )}
          </EmptyView >
        ) : (
          <>
            <div className="pb-3">
              <div className="row">
                <div className="col-12 col-md-3 align-self-center">
                  <SearchBar
                    label="Chercher un produit"
                    value={this.state.searchTerm}
                    onChange={(e) => handleSearchChange(e, this)}
                    onClick={() => getSections(this)}
                  />
                </div>
                <div className="col-12 col-md-9 d-flex flex-column flex-md-row-reverse mt-3 mt-md-0">
                  <div className="d-flex mb-3 mb-md-0 ml-sm-2">
                    {shopSync && nbShopsToSync > 1 ? (
                      <>
                        <Button
                          className="btn-block"
                          onClick={(e) =>
                            POSSync
                              ? handleDisplayMenu(e, this)
                              : nbShops === 2
                                ? showConfirmation(this, SYNC_SHOPS)
                                : this.setState({
                                  selectedShops: {
                                    [getShopId()]: getShopsToSynchronise()[getShopId()],
                                  },
                                  showModal: true,
                                  searchTerm: '',
                                  isAllMenu: true,
                                  isSuppression: false,
                                })
                          }
                          outlined
                          color="secondary"
                        >
                          <div className="row justify-content-center align-items-center mr-0 ml-0">
                            <SyncIcon />
                            <p className="m-0 ml-2">Synchronisation</p>
                          </div>
                        </Button>
                        {displayMenu && this.renderMenu()}
                      </>
                    ) : (
                      displayMenu && (
                        <>
                          <Button
                            className="btn-block"
                            onClick={() => showConfirmation(this, SYNC_POS)}
                            outlined
                            color="secondary"
                          >
                            <div className="row justify-content-center align-items-center mr-0 ml-0">
                              <SyncIcon />
                              <p className="m-0 ml-2">Synchroniser avec la caisse</p>
                            </div>
                          </Button>
                        </>
                      )
                    )}
                  </div>
                  <div className="d-flex mb-md-0 ml-sm-2">
                    {this.renderCreateSectionButton()}
                  </div>
                </div>
              </div>
              <SortableList
                list={sortedSections(this, rowsPerPage)}
                activeId={activeId}
                startegy={verticalListSortingStrategy}
                handleDragEnd={(e) => handleDragSection(e, sortedSections(this), this)}
                handleDragStart={(e) => {
                  handleChangeExpend(e, false, false, this);
                  handleStartDrag(e, this);
                }}
                handleDragMove={() => { }}
                expandedIndex={expanded}
                renderItem={(sectionKey, handleProps) =>
                  this.renderSectionItem(sectionKey, handleProps, sections)
                }
              />
            </div>
            <TableFooter
              rowsPerPageOptions={[10, 20, 50]}
              lengthOption={_.size(sections)}
              isSearch={isStringNotNull(this.state.searchTerm)}
            />
          </>
        )}
        {this.renderUpdateSection(nbShopsToSync)}
        {showModal && this.renderShops(classes, shopId)}
      </div >
    );
  }
}

function mapStateToProps({ user, firebaseRealTime, page }) {
  const { storageBucket = {}, shopId, nbShops, generalAdmin } = user;
  const { shop = {}, generalConfig, shops, menu = {} } = firebaseRealTime;
  const { marketplace = {} } = generalConfig;
  const { sections = {}, categories = {} } = menu;
  const { configuration = {} } = shop;
  const { externalIntegration = {} } = configuration;
  const { configuration: externalIntegrationConfiguration } = externalIntegration;
  return {
    configuration,
    categories,
    shopId,
    shops,
    page,
    storageBucket,
    sections,
    marketplace: marketplace.enabled,
    nbShops,
    menu,
    externalIntegrationConfiguration,
    generalAdmin
  };
}

Products.propTypes = {
  classes: PropTypes.element.isRequired
};

export default connect(mapStateToProps, actions)(withStyles(styles)(Products));
